import styled from 'styled-components';

export const Container = styled.div`
  overflow-y: auto;
  height: 100%;
`;
